var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopcorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12.892 2 13.6931 2.38929 14.2426 3.00724C16.0164 3.11333 17.4787 4.37536 17.8866 6.05028C18.5277 6.22079 19 6.80523 19 7.5H5C5 6.84645 5.41797 6.29052 6.00118 6.08494C6.00039 6.05672 6 6.02841 6 6C6 4.34315 7.34315 3 9 3C9.23895 3 9.47137 3.02794 9.69418 3.08072C10.2445 2.42031 11.0732 2 12 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0607 22H16.9191C17.4367 22 17.8688 21.605 17.9151 21.0894L18.4025 15.6582L12.0607 22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6116 13.3277L19 9H18.0607L6.07556 20.9851L6.08492 21.0894C6.13119 21.605 6.56328 22 7.08092 22H9.93932L18.6116 13.3277Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90086 19.0385L5.49908 14.5615L11.0607 9H15.9393L5.90086 19.0385Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H8.93934L5.32442 12.6149L5 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopcorn);
export default __webpack_public_path__ + "static/media/popcorn.75ce1a779e4c36b0be89bfedd3a5afe8.svg";
export { ForwardRef as ReactComponent };